<template>
    <div class="rounded-3xl bg-zinc-100 p-7 ring-1 ring-zinc-600">
        <div class="mb-3">
            To continue you need an account on the {{ $config.public.siteName }} website.
            You can use an existing account or create a new one.
        </div>
        <div class="mb-2 mt-6 flex flex-col space-y-5">
            <ButtonBlock
                buttonText="Sign In"
                buttonRoute="/login"
                buttonPadding="px-4 py-5"
                buttonColor="border border-zinc-200 bg-white text-black hover:border-zinc-300 focus-visible:outline-zinc-600"
            ></ButtonBlock>
            <ButtonBlock
                buttonText="Create Account"
                buttonRoute="/signup"
                buttonPadding="px-4 py-5"
                buttonColor="border border-zinc-200 bg-white text-black hover:border-zinc-300 focus-visible:outline-zinc-600"
            ></ButtonBlock>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContainerSubscriptionLogin',
};
</script>
